import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import ErpPage from "../pages/ErpPage";
import ShopwarePage from "../pages/ShopwarePage";
import BusinessAppsPage from "../pages/BusinessAppsPage";
import MobileAppsPage from "../pages/MobileAppsPage";
import InterfacesPage from "../pages/InterfacesPage";
import PortalsPage from "../pages/PortalsPage";
import SalescockpitPage from "../pages/SalescockpitPage";
import ReferencesPage from "../pages/ReferencesPage";
import AboutPage from "../pages/AboutPage";
import CtoServicePage from "../pages/CtoServicePage";
import DatenschutzPage from "../pages/DatenschutzPage";
import ImpressumPage from "../pages/ImpressumPage";
import AgbPage from "../pages/AgbPage";
import NotFound from "../pages/NotFound";
import ConsultingPage from "../pages/ConsultingPage";
import ECommercePage from '@/pages/ECommercePage';
import ShopwareLandingPage from "@/pages/ShopwareLandingPage";

export const AppRoutes = () => (
  <Routes>
    {/* Deutsche SEO-optimierte Routen */}
    <Route path="/de" element={<HomePage />} />
    <Route path="/de/startseite" element={<HomePage />} />
    <Route path="/de/beratung" element={<ConsultingPage />} />
    <Route path="/de/erp-systeme" element={<ErpPage />} />
    <Route path="/de/shopware" element={<ShopwarePage />} />
    <Route path="/de/business-anwendungen" element={<BusinessAppsPage />} />
    <Route path="/de/mobile-apps" element={<MobileAppsPage />} />
    <Route path="/de/schnittstellen" element={<InterfacesPage />} />
    <Route path="/de/portale" element={<PortalsPage />} />
    <Route path="/de/salescockpit" element={<SalescockpitPage />} />
    <Route path="/de/referenzen" element={<ReferencesPage />} />
    <Route path="/de/ueber-uns" element={<AboutPage />} />
    <Route path="/de/cto-service" element={<CtoServicePage />} />
    <Route path="/de/datenschutz" element={<DatenschutzPage />} />
    <Route path="/de/impressum" element={<ImpressumPage />} />
    <Route path="/de/agb" element={<AgbPage />} />
    <Route path="/de/e-commerce" element={<ECommercePage />} />
    <Route path="/de/shopware-entwicklung" element={<ShopwareLandingPage />} />

    {/* Bestehende Routen für Abwärtskompatibilität */}
    <Route path="/" element={<HomePage />} />
    <Route path="/consulting" element={<ConsultingPage />} />
    <Route path="/erp" element={<ErpPage />} />
    <Route path="/shopware" element={<ShopwarePage />} />
    <Route path="/business-apps" element={<BusinessAppsPage />} />
    <Route path="/mobile-apps" element={<MobileAppsPage />} />
    <Route path="/interfaces" element={<InterfacesPage />} />
    <Route path="/portals" element={<PortalsPage />} />
    <Route path="/salescockpit" element={<SalescockpitPage />} />
    <Route path="/references" element={<ReferencesPage />} />
    <Route path="/about" element={<AboutPage />} />
    <Route path="/cto-service" element={<CtoServicePage />} />
    <Route path="/datenschutz" element={<DatenschutzPage />} />
    <Route path="/impressum" element={<ImpressumPage />} />
    <Route path="/agb" element={<AgbPage />} />
    <Route path="/e-commerce" element={<ECommercePage />} />
    <Route path="/shopware-entwicklung" element={<ShopwareLandingPage />} />
    
    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes; 